import { PillRemovable } from '#components/atoms/pill/PillRemovable.tsx';

type Props = {
  onClick: () => void;
  label: string;
  className?: string;
};

export function FilterPill({ onClick, label, className }: Props) {
  return (
    <PillRemovable size="large" className={className} onRemove={onClick}>
      {label}
    </PillRemovable>
  );
}
